import { useEffect } from 'react';
/**
 * Хук, который отрабатывает единожды при монтировании компонента.
 *
 * @param effect React эффект
 * @example
 * ```tsx
 * const Component = () => {
 *   useMountEffect(() => {
 *     // Выполняется только при первом монтировании компонента
 *     console.log('Component mounted');
 *     fetchInitialData();
 *
 *     // Функция очистки выполнится при размонтировании
 *     return () => {
 *       console.log('Component unmounted');
 *     };
 *   });
 *
 *   return <div>Component content</div>;
 * };
 *
 * // Использование для инициализации аналитики
 * const AnalyticsComponent = () => {
 *   useMountEffect(() => {
 *     analytics.init();
 *     analytics.track('page_view');
 *   });
 *
 *   return <div>Analytics enabled</div>;
 * };
 *
 * // Использование для загрузки данных
 * const DataComponent = () => {
 *   const [data, setData] = useState(null);
 *
 *   useMountEffect(() => {
 *     fetch('/api/data')
 *       .then(response => response.json())
 *       .then(setData);
 *   });
 *
 *   if (!data) return <div>Loading...</div>;
 *   return <div>{data}</div>;
 * };
 * ```
 */
export function useMountEffect(effect) {
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Нужно для единичного вызова хука на маунт
    useEffect(effect, []);
}
